import React, { useEffect, useRef, useState,useReducer} from "react";
import { useNavigate } from "react-router-dom";
import CanvasDarkness from "./CanvasDarkness";
import CanvasDarkness2 from "./CanvasDarkness2";
import BacteriaManager from "./BacteriaManager.js";
import { useTrajectory } from "./useTrajectory";
import { useStationaryEffect } from "./useStationaryEffect";
import { useGlobalTime } from "./useGlobalTime";
import { useMapBounds } from "./useMapBounds"; // カスタムフックをインポート
import { useCalculateArea } from "./calculateArea"; // 
import Recorder from "../classes/Recorder.js"; // 菌記録用
import Report from "./Report/Report.jsx";
import useTrajectory2 from "./usetrajectory2.jsx";
import { RecordingStatus } from "./enum.js";
import useDynamicGlobalTime from "./dynamicGlobalTime.jsx";
import { distance } from "@turf/turf";

/** シミュレーション・描画設定 */
let recorder = null;

export default function TrajectoryManager_tama({
  map,
  tripData,
  stopData,
  playbackSpeed=100,
  onTimeUpdate,
  startTimestamp,
  showRepot,
  setShowReport,
  recordingStatus,
  setRecordingStatus,
  trainCoverage = 500,
  busCoverage = 300,
  reverse=false
}) {
  const bounds = useMapBounds(map, 0.8); // カスタムフックを使用してバウンディングボックスを取得
  const [bacteriaManager, setBacteriaManager] = useState(null);
  const [visualizeingObjects, setVisualizingObjects] = useState([]);
  const [record,setRecord] = useState(null); // レポート作成用のデータ

  /** 描画するかコントロールする */
  const [visualMimizu, setVisualMimizu] = useState(false);
  const [visualizeStopEffect, setVisualizeStopEffect] = useState(false);
  const [simulateBacteria, setSimulateBacteria] = useState(true);
  const [visualBacteria, setVisualBacteria] = useState(false);

  // `useDynamicGlobalTime` を使用して currentTime を取得
  const currentTime = useDynamicGlobalTime(playbackSpeed, startTimestamp);

  
  useEffect(() => {
    if (onTimeUpdate) {
      onTimeUpdate(currentTime);
    }
  }, [currentTime, onTimeUpdate]);

  useEffect(() => {
    if (!map) return;
  
    const handleZoomChange = () => {
      const currentZoom = map.getZoom();
      //console.log("Current Zoom Level:", currentZoom);

  
      if (currentZoom < 13) {
        //console.log("station on");
        setVisualMimizu(true);
        setVisualizeStopEffect(true); // 状態を更新
        setVisualBacteria(false);
       
      } else if (15 > currentZoom && currentZoom >= 13){
        //console.log("bacteria on");
        setVisualMimizu(true);
        setVisualizeStopEffect(true); // 状態を更新
        setVisualBacteria(false);
     
      } else {
        setVisualMimizu(true);
        setVisualizeStopEffect(false); // 状態を更新
        setVisualBacteria(true);
       
      }
    };
  
    // 初期化およびズームイベント登録
    handleZoomChange(); // 初期化時に実行
    map.on("zoom", handleZoomChange);
  
    // クリーンアップ処理
    return () => {
      map.off("zoom", handleZoomChange);
    };
  }, [map]);



  /** 菌のシミュレート */
  useEffect(() => { // 初期化
    if (!bacteriaManager && simulateBacteria) { // 未初期化かつシミュレーションを実行する場合
      setBacteriaManager(new BacteriaManager(startTimestamp)); // managerのインスタンス生成
    }
  },[]);

  useEffect(() => { // シミュレーションの外部更新操作（外のタイマーに依存する処理をここで行う）
    if (!bacteriaManager || !simulateBacteria ) { return; } // 初期化前ORシミュレーションしていない場合はスキップ
    // stop内部のシミュレーションの外部依存の部部に更新をかける
    if (bacteriaManager.stops.length !== 0){
      bacteriaManager.run(currentTime); // 秒のタイムスタンプを渡す．
    }
    // 描画用にobjectとして取り出す
    if (visualBacteria){ // 菌を可視化する設定の時のみ
      setVisualizingObjects(bacteriaManager.getVisualizingObjects()); // 描画対象（描画範囲外を含む）のオブジェクトを全取得    
    }else{
      setVisualizingObjects([])
    }

    // リポート用の記録開始分岐
    if (recordingStatus === RecordingStatus.START){ // 記録開始ボタンが押されたら
      setRecordingStatus(RecordingStatus.IN_PROGRESS); // 記録中に更新
      const center = map.getCenter();
      const mapBounds = map.getBounds();
      const rOfRecordingArea = distance([center.lng,center.lat], [center.lng,mapBounds.getNorth()], {units:"meters"})*0.7;
      //console.log("rOfRecordingArea",rOfRecordingArea);
      recorder = new Recorder(currentTime,center.lat, center.lng,bacteriaManager.stops,rOfRecordingArea);
    } 

    if ( recorder !== null && recordingStatus === RecordingStatus.IN_PROGRESS && recorder.doIt(currentTime)){
      setRecordingStatus(RecordingStatus.COMPLETED); // 完了に変更
      setRecord(recorder);
    }

  },[currentTime])




  const opacity = 0.001; // 不透明度を定義

// 定点エフェクトのhistoryデータを生成
let stationaryEffectHistories;

stationaryEffectHistories = useStationaryEffect(
    stopData,
    currentTime,
    {trainCoverage: trainCoverage, busCoverage: busCoverage},
    opacity,
    "grad",
    visualizeStopEffect,
    playbackSpeed
  );
    

//軌跡データのデータ収集
  const histories = useTrajectory2({
    dataList: tripData, // 正しいキー名で渡す
    currentTime,
    baseHistoryLength: 10,
    R: 5,
    Color: "#4169e1",
    Opacity: 0.5,
    Type: "none",
    isActive:visualMimizu,
  });

  // console.log(visualMimizu)


  // flatten & filter
  const filteredEffectHistories = stationaryEffectHistories
  .filter((arr) => arr.length > 0) // 空配列を除外
  .flat()
  .filter(({ lat, lng }) => 
    bounds &&
    lat > bounds.minLat && lat < bounds.maxLat &&
    lng > bounds.minLng && lng < bounds.maxLng
  );

// ---- 3) もし bacteriaManager などからオブジェクトを得ているなら同様に
// const visualizeingObjects = ...
// flatten & filter
const filteredObjects = visualizeingObjects
  .flat()
  .filter(({ lat, lng }) =>
    bounds &&
    lat > bounds.minLat && lat < bounds.maxLat &&
    lng > bounds.minLng && lng < bounds.maxLng
  );

// ---- 4) useTrajectory2 の履歴にも同じフィルタをかける
// histories は既にフラットな配列なので .flat() は不要
const filteredTrajectoryHistories = histories.filter(({ lat, lng }) =>
  bounds &&
  lat > bounds.minLat && lat < bounds.maxLat &&
  lng > bounds.minLng && lng < bounds.maxLng
);

// ---- 5) すべての可視ヒストリを統合
const visibleHistories = [
  ...filteredTrajectoryHistories,   // useTrajectory2で得た履歴
  ...filteredEffectHistories,       // stop到着エフェクト
  ...filteredObjects,               // 菌オブジェクト など
];



return (
  <div>
    {/* リポートのコンポーネント */}
    {showRepot && (
      <Report
        record={record}
        setShowReport={setShowReport}
      />
    )}
    {/* CanvasDarkness コンポーネント */}
    {!showRepot && map && (
    reverse ? (
    <CanvasDarkness2
      map={map}
      darknessOpacity={0.7}
      histories={visibleHistories} // historiesを統合
    />
  ) : (
    <CanvasDarkness
      map={map}
      darknessOpacity={0.7}
      histories={visibleHistories} // historiesを統合
    />
  )
)}

  </div> 
)
}
